import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 端OpenVideo
import OpenVideo from '../OpenVideo';
// 端外player
import PlayerVideo from '../PlayerVideo';
// 数据源
import { ListStore } from '../../../store';
// 统计埋点
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { getQuery } from '@src/utils/url';
import { Grounds } from '@ifeng-fe/client_grounds';

// 干预层：处理本地数据与视频数据的交集
const VideoWrap = ({ content }) => {
    // 列表数据源
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { currentVideo, dramaSeries } = listStates;
    const [isSent, setIsSent] = useState(false);

    // 页面统计
    const sendPage = () => {
        const id = getQuery(window.location.href, 'id') || '';
        const ref = getQuery(window.location.href, 'ref') || Grounds.getPageInfo?.()?.getRef?.() || '';
        const type = getQuery(window.location.href, 'type') || '';
        const reftype = getQuery(window.location.href, 'reftype') || '';
        const rnum = getQuery(window.location.href, 'rnum') || Grounds.getPageInfo?.()?.getRnum?.() || '';
        const showtype = getQuery(window.location.href, 'showtype') || Grounds.getPageInfo?.()?.getShowtype?.() || '';

        switch (showtype) {
            case 'guesschase': // 猜你想追
                Grounds.pageStat({
                    behavior: 'page',
                    id,
                    ref,
                    type,
                    reftype,
                    showtype,
                    rnum,
                });
                // 跳转后页面播放视频
                Grounds.pageStat({
                    behavior: 'page',
                    id: `video_${currentVideo.base62Id}`,
                    reftype,
                    rnum,
                    ref: `phmovie_${dramaSeries.base62Id}`,
                    type: 'video',
                    showtype: 'phplay',
                });
                break;
            case 'phhit': // 正在热播
                Grounds.pageStat({
                    behavior: 'page',
                    id,
                    ref,
                    type,
                    reftype,
                    showtype,
                    rnum,
                });

                // 跳转后页面播放视频
                Grounds.pageStat({
                    behavior: 'page',
                    id: `video_${currentVideo.base62Id}`,
                    reftype,
                    rnum,
                    ref: `phmovie_${dramaSeries.base62Id}`,
                    type: 'video',
                    showtype: 'phplay',
                });
                break;
            case 'glsmallpix': // 猜你喜欢小图
                Grounds.pageStat({
                    behavior: 'page',
                    id,
                    ref,
                    type,
                    reftype,
                    showtype,
                    rnum,
                });

                // 跳转后页面播放视频
                Grounds.pageStat({
                    behavior: 'page',
                    id: `video_${currentVideo.base62Id}`,
                    reftype,
                    rnum,
                    ref: `phmovie_${dramaSeries.base62Id}`,
                    type: 'video',
                    showtype: 'phplay',
                });

                break;
            case 'glbigpix': // 猜你喜欢大图
                Grounds.pageStat({
                    behavior: 'page',
                    id,
                    ref,
                    type,
                    reftype,
                    showtype,
                    rnum,
                });

                // 跳转后页面播放视频

                Grounds.pageStat({
                    behavior: 'page',
                    id: `video_${currentVideo.base62Id}`,
                    reftype,
                    rnum,
                    ref: `phmovie_${dramaSeries.base62Id}`,
                    type: 'video',
                    showtype: 'phplay',
                });
                break;
            default:
                // 默认只发一中，其他发两种
                Grounds.pageStat({
                    behavior: 'page',
                    id,
                    ref,
                    type,
                    reftype,
                    showtype,
                    rnum,
                });
                break;
        }
    };

    useEffect(
        () => {
            //  视频存在 || 跳转页面进入(判断是否第一次加载)
            if (currentVideo.videoPlayUrl && !isSent) {
                setIsSent(true);
                sendPage();
            }
        },
        [currentVideo],
    );

    return <>{window.grounds ? <OpenVideo content={content} /> : <PlayerVideo />}</>;
};

VideoWrap.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(VideoWrap);
